export default [
  {
    title: "Mission ",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Friend Referral ",
        route: "custom-mission-friend-referral-list",
        path: "/custom-mission/friend-referral-list",
      },
      // {
      //   title: "Mission Group List",
      //   route: "custom-mission-mission-group-list",
      //   path: "/custom-mission/mission-group-list",
      // },
    ],
  },
];
